/*
 * 配送module
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-30 20:20:31
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-08-06 15:24:48
 */

import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { NProgressLoading as Loading } from 'components';

const Spin = () => <Loading loading />;

const Main = Loadable({
	loader: () => import('./main'),
	loading: Spin,
});

export default ({ match }) => {
	return (
		<Switch>
			<Route path={match.url} component={Main} />
		</Switch>
	);
};
